module.exports = __webpack_public_path__ + "assets/img/theX-content-8.83a9af7f.png";